import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0db88d02"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Refresh account")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_Button, {
      loading: _ctx.refreshLoad,
      block: "",
      onClick: _ctx.refreshFarmer
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["loading", "onClick"])
  ]))
}